import React, { useState, useEffect, useRef } from 'react';
import './Développement-Web.css';
import Header from '../Header/Header';
import Footer from '../footer/footer';
import { motion, AnimatePresence } from 'framer-motion';
import TopAnnouncementBar from '../TopAnnouncementBar/TopAnnouncementBar';
import WhatsAppButton from '../whatsapp/WhatsAppButton';
import { Link } from 'react-router-dom';
import { 
  FaRocket, 
  FaChevronRight,
  FaMobileAlt, 
  FaSearch, 
  FaShieldAlt,
  FaShoppingCart,
  FaCode,
  FaCloud,
  FaDatabase,
  FaTools,
  FaArrowRight,
  FaCheckCircle,
  FaAward,
  FaUsers,
  FaClock
} from 'react-icons/fa';
import { 
  SiNextdotjs, 
  SiTailwindcss,
  SiTypescript,
  SiMongodb,
  SiDocker,
  SiGraphql,
  SiReact,
  SiNodedotjs
} from 'react-icons/si';
import { MdAutoAwesome, MdOutlineSpeed, MdOutlineSecurity, MdOutlineSupportAgent, MdWeb, MdDesignServices, MdAnalytics, MdIntegrationInstructions } from 'react-icons/md';
import { GiAstronautHelmet, GiStarsStack, GiGalaxy, GiSpiralShell, GiCrystalBall, GiCyberEye, GiArtificialIntelligence, GiThunderSkull, GiBrain, GiRocketThruster } from 'react-icons/gi';

const DeveloppementWeb = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isCursorActive, setIsCursorActive] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef(null);
  let cursorTimeout;

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsCursorActive(true);
      
      clearTimeout(cursorTimeout);
      cursorTimeout = setTimeout(() => setIsCursorActive(false), 100);
    };
    
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const scrollPercent = Math.min(1, Math.max(0, -rect.top / (rect.height - window.innerHeight)));
        setScrollProgress(scrollPercent);
      }
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(cursorTimeout);
    };
  }, []);

  const solutionsData = [
    {
      title: "Sites Vitrine Nouvelle Génération",
      tagline: "L'élégance qui convertit",
      description: "Des sites web qui allient esthétique raffinée et performance technique pour captiver vos visiteurs dès la première seconde.",
      features: ["Design signature unique", "Animations fluides", "SEO intégré", "Formulaire intelligent"],
      icon: <MdWeb />,
      color: "#3B82F6",
      stat: "+45% de conversion"
    },
    {
      title: "E-commerce Immersif",
      tagline: "Vendez, partout, tout le temps",
      description: "Des boutiques en ligne qui transforment chaque visiteur en client grâce à une expérience d'achat fluide et sécurisée.",
      features: ["Paiement 1-clic", "Gestion des stocks", "Abonnements", "Retargeting automatique"],
      icon: <FaShoppingCart />,
      color: "#10B981",
      stat: "+128% de ventes"
    },
    {
      title: "Applications Web Métier",
      tagline: "Digitalisez vos processus",
      description: "Des solutions sur-mesure qui automatisent vos tâches et boostent la productivité de vos équipes.",
      features: ["Tableaux de bord temps réel", "Workflows personnalisés", "API dédiées", "Reporting avancé"],
      icon: <FaDatabase />,
      color: "#8B5CF6",
      stat: "75% de temps gagné"
    },
    {
      title: "PWA & Mobile-First",
      tagline: "Le web, comme une app",
      description: "Des applications web progressives qui fonctionnent hors ligne et offrent une expérience native sur tous les appareils.",
      features: ["Installation directe", "Notifications push", "Mode hors ligne", "Performance maximale"],
      icon: <FaMobileAlt />,
      color: "#EC4899",
      stat: "2x plus d'engagement"
    }
  ];

  const benefits = [
    { icon: <MdOutlineSpeed />, title: "Ultra-rapide", description: "Chargement < 1 seconde", color: "#3B82F6" },
    { icon: <FaShieldAlt />, title: "Sécurité renforcée", description: "Protection proactive", color: "#10B981" },
    { icon: <FaSearch />, title: "Référencement n°1", description: "Premiers sur Google", color: "#8B5CF6" },
    { icon: <MdAnalytics />, title: "Analytics avancé", description: "Suivi des conversions", color: "#F59E0B" },
    { icon: <MdIntegrationInstructions />, title: "Intégrations illimitées", description: "CRM, API, outils", color: "#06B6D4" },
    { icon: <FaUsers />, title: "UX/UI centrée humain", description: "Taux de conversion optimisé", color: "#EC4899" }
  ];

  const statsData = [
    { value: "250+", label: "projets livrés", icon: <FaRocket /> },
    { value: "99%", label: "clients satisfaits", icon: <FaAward /> },
    { value: "< 1s", label: "temps de charge", icon: <MdOutlineSpeed /> },
    { value: "24/7", label: "support prioritaire", icon: <FaClock /> }
  ];

  const technologies = [
    { icon: <SiReact />, name: "React 18", color: "#61DAFB" },
    { icon: <SiNextdotjs />, name: "Next.js 14", color: "#FFFFFF" },
    { icon: <SiNodedotjs />, name: "Node.js", color: "#68A063" },
    { icon: <SiTypescript />, name: "TypeScript", color: "#3178C6" },
    { icon: <SiTailwindcss />, name: "Tailwind", color: "#38BDF8" },
    { icon: <SiMongodb />, name: "MongoDB", color: "#47A248" },
    { icon: <SiDocker />, name: "Docker", color: "#2496ED" },
    { icon: <SiGraphql />, name: "GraphQL", color: "#E10098" }
  ];

  const getPreviewBadgeText = () => {
    switch(activeTab) {
      case 0: return "Vitrine haute performance";
      case 1: return "E-commerce nouvelle génération";
      case 2: return "Solution métier sur-mesure";
      case 3: return "PWA & Mobile-first";
      default: return "Solution premium";
    }
  };

  return (
    <div className="dw-container" ref={sectionRef}>
      <WhatsAppButton />
      <TopAnnouncementBar />
      <Header />
      
      {/* Cursor Glow */}
      <motion.div 
        className={`dw-cursor-glow ${isCursorActive ? 'active' : ''}`}
        animate={{
          x: mousePosition.x - 300,
          y: mousePosition.y - 300,
        }}
        transition={{ type: "spring", damping: 30, stiffness: 200, mass: 0.5 }}
      />

      {/* Particles */}
      <div className="dw-particles">
        {[...Array(60)].map((_, i) => (
          <div key={i} className="dw-particle" style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 20}s`,
            animationDuration: `${20 + Math.random() * 30}s`,
            width: `${1.5 + Math.random() * 3}px`,
            height: `${1.5 + Math.random() * 3}px`,
          }} />
        ))}
      </div>

      {/* Animated Orbs */}
      <div className="dw-orbs">
        <div className="dw-orb dw-orb-1" style={{ transform: `translate(${scrollProgress * 100}px, ${scrollProgress * 50}px)` }} />
        <div className="dw-orb dw-orb-2" style={{ transform: `translate(-${scrollProgress * 80}px, -${scrollProgress * 60}px)` }} />
        <div className="dw-orb dw-orb-3" style={{ transform: `translate(${scrollProgress * 60}px, -${scrollProgress * 40}px)` }} />
        <div className="dw-orb dw-orb-4" style={{ transform: `translate(-${scrollProgress * 70}px, ${scrollProgress * 70}px)` }} />
      </div>

      {/* Floating Elements */}
      <div className="dw-floating">
        <GiGalaxy className="dw-float dw-float-1" />
        <GiSpiralShell className="dw-float dw-float-2" />
        <GiAstronautHelmet className="dw-float dw-float-3" />
        <GiStarsStack className="dw-float dw-float-4" />
        <GiCrystalBall className="dw-float dw-float-5" />
        <GiCyberEye className="dw-float dw-float-6" />
        <GiArtificialIntelligence className="dw-float dw-float-7" />
        <GiThunderSkull className="dw-float dw-float-8" />
        <GiBrain className="dw-float dw-float-9" />
        <GiRocketThruster className="dw-float dw-float-10" />
      </div>
      
      {/* ========== HERO BANNER ========== */}
      <section className="dw-hero">
        <div className="dw-hero-overlay"></div>
        <div className="dw-hero-inner">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="dw-hero-badge"
          >
            <GiRocketThruster />
            <span>Web Development Excellence</span>
            <GiStarsStack />
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="dw-hero-title"
          >
            Des sites web qui ne se contentent pas d'être beaux,<br />
            <span className="dw-gradient-text">ils dominent</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="dw-hero-subtitle"
          >
            Nous créons des expériences digitales sur-mesure qui allient design audacieux, 
            performance fulgurante et conversion optimisée.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.3 }}
            className="dw-hero-buttons"
          >
            <Link to="/reservation-appel">
              <button className="dw-btn dw-btn-primary">
                <MdAutoAwesome /> Lancer mon projet <FaArrowRight />
              </button>
            </Link>
            <Link to="/realisations">
              <button className="dw-btn dw-btn-secondary">
                <FaCode /> Explorer nos créations
              </button>
            </Link>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="dw-hero-stats"
          >
            {statsData.map((stat, idx) => (
              <div key={idx} className="dw-stat-card">
                <div className="dw-stat-icon">{stat.icon}</div>
                <div className="dw-stat-value">{stat.value}</div>
                <div className="dw-stat-label">{stat.label}</div>
              </div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* ========== BENEFITS SECTION ========== */}
      <section className="dw-benefits">
        <div className="dw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dw-section-header"
          >
            <div className="dw-badge">Pourquoi nous</div>
            <h2>L'excellence <span className="dw-gradient-text">technique et humaine</span></h2>
            <p>Chaque projet est une œuvre unique, pensée pour performer et durer</p>
          </motion.div>

          <div className="dw-benefits-grid">
            {benefits.map((benefit, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -8 }}
                className="dw-benefit-card"
                style={{ '--dw-card-color': benefit.color }}
              >
                <div className="dw-benefit-icon" style={{ color: benefit.color }}>{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
                <div className="dw-benefit-glow" style={{ background: `radial-gradient(circle, ${benefit.color}20, transparent)` }} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== SOLUTIONS SECTION - TABS ========== */}
      <section className="dw-solutions">
        <div className="dw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dw-section-header"
          >
            <div className="dw-badge">Nos solutions</div>
            <h2>Des créations <span className="dw-gradient-text">sur mesure</span></h2>
            <p>Nous ne faisons pas de template — chaque projet est une création originale</p>
          </motion.div>

          {/* Tabs navigation */}
          <div className="dw-tabs-nav">
            {solutionsData.map((sol, idx) => (
              <button
                key={idx}
                className={`dw-tab-btn ${activeTab === idx ? 'active' : ''}`}
                onClick={() => setActiveTab(idx)}
                style={{ '--dw-tab-color': sol.color }}
              >
                <span className="dw-tab-icon">{sol.icon}</span>
                <span className="dw-tab-title">{sol.title}</span>
              </button>
            ))}
          </div>

          {/* Tab content */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4 }}
              className="dw-tab-content"
            >
              <div className="dw-tab-left">
                <div className="dw-solution-tagline" style={{ color: solutionsData[activeTab].color }}>
                  {solutionsData[activeTab].tagline}
                </div>
                <h3>{solutionsData[activeTab].title}</h3>
                <p>{solutionsData[activeTab].description}</p>
                <div className="dw-features-list">
                  {solutionsData[activeTab].features.map((feat, i) => (
                    <div key={i} className="dw-feature-item">
                      <FaCheckCircle style={{ color: solutionsData[activeTab].color }} />
                      <span>{feat}</span>
                    </div>
                  ))}
                </div>
                <div className="dw-solution-stat" style={{ background: `${solutionsData[activeTab].color}15`, borderLeftColor: solutionsData[activeTab].color }}>
                  <FaRocket />
                  <span><strong>{solutionsData[activeTab].stat}</strong></span>
                </div>
              </div>
              <div className="dw-tab-right">
                <div className="dw-preview-card" style={{ background: `linear-gradient(135deg, ${solutionsData[activeTab].color}10, rgba(10,17,40,0.4))` }}>
                  <div className="dw-preview-icon" style={{ color: solutionsData[activeTab].color }}>
                    {solutionsData[activeTab].icon}
                  </div>
                  <div className="dw-preview-badge">
                    {getPreviewBadgeText()}
                  </div>
                  <div className="dw-preview-stats">
                    <span>⚡ Performance</span>
                    <span>🔒 Sécurisé</span>
                    <span>📱 Responsive</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>

      {/* ========== TECHNOLOGIES SECTION ========== */}
      <section className="dw-tech">
        <div className="dw-container-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dw-section-header"
          >
            <div className="dw-badge">Stack technique</div>
            <h2>Les <span className="dw-gradient-text">meilleurs outils</span> pour vos projets</h2>
            <p>Nous sélectionnons les technologies les plus adaptées à vos objectifs</p>
          </motion.div>

          <div className="dw-tech-grid">
            {technologies.map((tech, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
                whileHover={{ y: -5 }}
                className="dw-tech-card"
              >
                <div className="dw-tech-icon" style={{ color: tech.color }}>{tech.icon}</div>
                <h4>{tech.name}</h4>
                <div className="dw-tech-bar">
                  <div className="dw-tech-progress" style={{ backgroundColor: tech.color }} />
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== FINAL CTA ========== */}
      <section className="dw-final-cta">
        <div className="dw-cta-pattern"></div>
        <div className="dw-cta-inner">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="dw-cta-icon"
          >
            <GiRocketThruster />
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            Prêt à <span className="dw-gradient-text">dominer</span> votre marché ?
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            Discutons de votre projet et construisons ensemble la solution qui fera la différence.
          </motion.p>
          <Link to="/reservation-appel">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="dw-cta-button"
            >
              <MdAutoAwesome /> Obtenir un audit gratuit <FaArrowRight />
            </motion.button>
          </Link>
          <div className="dw-cta-features">
            <div><FaCheckCircle /> Réponse sous 24h</div>
            <div><FaShieldAlt /> Garantie satisfait</div>
            <div><FaUsers /> Support dédié</div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DeveloppementWeb;